import {Injectable} from "@angular/core";
import {Http, Response} from "@angular/http";
import {Observable} from "rxjs";
import { map } from "rxjs/operators";
import {LoginObject} from "./login-object.model";
import {Session} from "./session.model";
import { environment } from '../../environments/environment';


@Injectable()
export class AuthService {

  constructor(private http: Http) {}

  private basePath = '/';

  login(loginObj: LoginObject): Observable<Session> {
    loginObj.client_id = environment.cliendId;
    return this.http.post(this.basePath + 'login', loginObj).pipe(map(this.extractData));
  }
    
  refresh() {
      
  }

  logout(): Observable<Boolean> {
    return this.http.post(this.basePath + 'logout', {}).pipe(map(this.extractData));
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }
}

